import React from "react";

// Import styles
import "../../styles/dashboard.css";

export interface WorkflowInfoColumn {
  label: string;
  value: React.ReactNode;
  /** Width hint: 'sm' (15%), 'md' (20%), 'lg' (25%), 'xl' (30%) - defaults to equal distribution */
  width?: "sm" | "md" | "lg" | "xl";
}

interface WorkflowInfoGridProps {
  columns: WorkflowInfoColumn[];
  className?: string;
}

/**
 * Reusable grid component for displaying workflow information
 * Ensures consistent alignment across all workflow cards
 */
const WorkflowInfoGrid: React.FC<WorkflowInfoGridProps> = ({ columns, className = "" }) => {
  return (
    <div className={`su-workflow-info-grid-fixed ${className}`}>
      {columns.map((col, idx) => (
        <div 
          key={idx} 
          className="su-workflow-info-col"
          data-width={col.width || "equal"}
        >
          <div className="su-workflow-info-label">{col.label}</div>
          <div className="su-workflow-info-value">{col.value}</div>
        </div>
      ))}
    </div>
  );
};

export default WorkflowInfoGrid;



